<template>
  <q-card
    flat bordered
  >
    <q-card-section
        class="q-pa-sm row justify-between items-center text-bold"
    >
       Today's Feed
    </q-card-section>
    <q-separator />
    <q-card-section>
      <q-markup-table>
        <thead>
          <tr>
            <th class="text-left">Time In</th>
            <th class="text-right">Time Out</th>
            <th class="text-right">Work Hours</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="{startedAt, endedAt, hours} in todayFeed" :key="startedAt">
            <td class="text-left">{{timed(startedAt)}}</td>
            <td class="text-right">{{timed(endedAt)}}</td>
            <td class="text-right">{{hours}}</td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card-section>
  </q-card>

</template>
<script>
  import graphql from '@client/graphql';
  import { formatString } from '@server/lib/date-helpers';

  export default {
    name: 'AppClockTodayFeed',
    components: {
    },
      apollo: {
        todayFeed: {
          query: graphql.queries.todayFeed,
          watchLoading(isLoading) {
            this.isLoading = isLoading;
          },
          result(result) {
            this.todayFeed = result?.data?.todayFeed;
          }
        }
      },
      data() {
        return {
          isLoading: false,
          todayFeed: []
        };
      },
      methods: {
        timed(date) {
          return formatString(date, 'hh:mm:ss a');
        }
      }
  };
</script>
<style lang="scss">
</style>
